<template>
  <!-- Modal -->
  <Modal
    id="delete-tag-modal"
    title="Sei sicuro di voler eliminare questo tag?"
    submit-btn-text="Elimina"
    :submit-btn-disabled="!tag"
    submit-btn-style="danger"
    @submit="remove()"
  >
    <div v-if="!tag">
      Non hai selezionato alcun tag da eliminare.
    </div>
    <div v-else>
      <p>Il tag <b>{{tag.name}}</b> contiene <b>{{messageCount}}</b> email. Le email non verranno eliminate, ma perderanno questo tag.</p>
      <p>Sei davvero sicuro di volerlo eliminare? Questa azione non è reversibile.</p>
    </div>
  </Modal>
</template>

<script setup>
import { ref, inject, onBeforeUnmount } from 'vue';
import bus from '@/bus.js';
import * as tagService from '@/services/tag.service.js';
import Modal from './Modal.vue';

const hideModal = inject('hideModal');

const tag = ref(null);
const messageCount = ref(null);
const accountId = ref('');

async function init(account, _tag) {
  accountId.value = account;
  tag.value = _tag;
  messageCount.value = await tagService.messageCount(accountId.value, tag.value.id);
}

async function remove() {
  await tagService.remove(accountId.value, tag.value.id);

  bus.$emit('tagRemoved', { account: accountId.value, tag: tag.value.id });

  hideModal('delete-tag-modal');
}

// Event listeners
bus.$on('init-delete-tag-modal', init);

onBeforeUnmount(() => {
  bus.$off('init-delete-tag-modal', init);
});

</script>
